import Vector from "../../../../../Assets/Images/eyebrow.svg";

const AdminPanelHead = (props) => {
  return (
    <div className="profile-head">
      <p className="name">Admin Panel</p>
      <img alt="" src={Vector} style={{ marginTop: "0" }} />
    </div>
  );
};

export default AdminPanelHead;
